import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell
} from 'recharts'
import styles from './WizardChart.module.css'

const COLORS = [
  '#234671',
  '#4BAF4F',
  '#E8871E',
  '#8E44AD',
  '#d22524',
  '#2196F3',
  '#FF9800',
  '#009688'
]

const formatGBP = (value: number) =>
  new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    maximumFractionDigits: 0
  }).format(value)

// ---------- Contractor / Benchmark Price Chart ----------

type PriceData = {
  contractor: string
  amount: number
}

type ContractorPriceChartProps = {
  data: PriceData[]
}

function ContractorPriceChart({ data }: ContractorPriceChartProps) {
  if (data.length === 0) return null

  const sorted = [...data].sort((a, b) => a.amount - b.amount)
  const chartHeight = Math.max(250, sorted.length * 50)

  return (
    <div className={styles.chartWrapper}>
      <ResponsiveContainer width="100%" height={chartHeight}>
        <BarChart data={sorted} layout="vertical" margin={{ left: 20, right: 30, top: 10, bottom: 10 }}>
          <XAxis
            type="number"
            tickFormatter={(v) => formatGBP(v)}
            style={{ fontFamily: 'Montserrat, sans-serif', fontSize: 12 }}
          />
          <YAxis
            type="category"
            dataKey="contractor"
            width={140}
            tick={{ fontFamily: 'Montserrat, sans-serif', fontSize: 12 }}
          />
          <Tooltip
            formatter={(value: number) => [formatGBP(value), 'Price']}
            contentStyle={{ fontFamily: 'Montserrat, sans-serif', fontSize: 13 }}
          />
          <Bar dataKey="amount" radius={[0, 4, 4, 0]}>
            {sorted.map((_, i) => (
              <Cell key={i} fill={COLORS[i % COLORS.length]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}

export { ContractorPriceChart }
